module.exports = __webpack_public_path__ + "img/portfolio1-m@1.7d5074db.webp";